//pilot.js
import { db } from "../firebase/config";
import {
  doc,
  getDoc,
  serverTimestamp,
  Timestamp,
  updateDoc,
} from "firebase/firestore";

const normalizeEmail = (email = "") =>
  String(email)
    .trim()
    .toLowerCase();

export async function isPilotEmail(email) {
  const key = normalizeEmail(email);
  if (!key) return { ok: false };

  const ref = doc(db, "pilot_allowlist", key);
  const snap = await getDoc(ref);

  if (!snap.exists()) return { ok: false };

  const data = snap.data() || {};
  if (data.active === false) return { ok: false };

  return {
    ok: true,
    trialDays: Number(data.trialDays || 60), // default pilot length
    data,
  };
}

export function computePilotEndsAt(days = 60) {
  const ms = Date.now() + Number(days) * 24 * 60 * 60 * 1000;
  return Timestamp.fromMillis(ms);
}

export async function ensureCompanyPilot(companyId, email, trialDays = 60) {
  const companyRef = doc(db, "companies", companyId);
  const companySnap = await getDoc(companyRef);
  if (!companySnap.exists()) throw new Error("Company not found.");

  const company = companySnap.data() || {};
  const pilot = company.pilot || null;

  // Already set? don’t overwrite.
  if (pilot?.enabled && pilot?.startedAt && pilot?.endsAt) {
    return { enabled: true, endsAt: pilot.endsAt };
  }

  const endsAt = computePilotEndsAt(trialDays);

  await updateDoc(companyRef, {
    pilot: {
      enabled: true,
      status: "active",
      allowlistEmail: normalizeEmail(email),
      startedAt: serverTimestamp(),
      endsAt,
    },
  });

  return { enabled: true, endsAt };
}

export function isPilotActive(pilotObj) {
  if (!pilotObj?.enabled) return false;

  // Firestore Timestamp shape
  const ends =
    typeof pilotObj.endsAt?.toDate === "function"
      ? pilotObj.endsAt.toDate()
      : typeof pilotObj.endsAt?.seconds === "number"
      ? new Date(pilotObj.endsAt.seconds * 1000)
      : null;

  if (!ends) return false;

  return Date.now() < ends.getTime();
}
